import "./App.css";
import React from "react";
import Answerquestion from "./Components/AnswerQuestion/Answerquestion";
import Login from "./Components/Login/Login";
import Postquestion from "./Components/PostQuestion/Postquestion";
import Questions from "./Components/Questions/Questions";
import { Routes, Route } from "react-router-dom";
import { useCookies } from "react-cookie";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import How from "./Components/How/How";

function App() {
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const authToken = cookies.AuthToken;
    return (
        <div className="app">
            <Routes>
                <Route
                    path="/"
                    element={
                        authToken ? (
                            <>
                                <Questions />
                            </>
                        ) : (
                            <>
                                <Login />
                                <Footer />
                            </>
                        )
                    }
                />
                {authToken && (
                    <Route
                        path="/questions"
                        element={
                            <>
                                <Header />
                                <Postquestion />
                                <Footer />
                            </>
                        }
                    />
                )}
                {authToken && (
                    <Route
                        path="/answers/:id"
                        element={
                            <>
                                <Answerquestion />
                            </>
                        }
                    />
                )}
                {authToken && (
                    <Route
                        path="/howitworks"
                        element={
                            <>
                                <Header />
                                <How />
                                <Footer />
                            </>
                        }
                    />
                )}
                <Route
                    path="*"
                    element={
                        <>
                            <Header />
                            <Login />
                            <Footer />
                        </>
                    }
                />
            </Routes>
        </div>
    );
}

export default App;
